<template>
  <v-app class="app-default" :class="{'app-transparent':transparent}">
    <!-- <v-toolbar height="40" class="header" dark fixed>
      <v-layout fill-height align-center :class="{'layout-wrap':!breakpoint.xs}">
        <v-toolbar-side-icon @click.stop="drawer=!drawer" class="bar-icon hidden-md-and-up"></v-toolbar-side-icon>
        <img src="/images/company-logo.png" width="43" height="12" style="margin-right: 12px;">
        |
        <v-toolbar-title class="caption">企业员工保险服务专家</v-toolbar-title>
        <v-spacer></v-spacer>
        <span
          class="caption caption-color hidden-sm-and-down"
          style="margin-right: 15px;"
        >客服与投诉电话：4006-234-345</span>
        <v-toolbar-items class="hidden-sm-and-down" hidden-md-and-down>
          <v-btn class="caption" to="/information" flat>信息披露</v-btn>
          <v-btn class="caption" to="/order" flat>保单管理</v-btn>
          <v-btn v-if="!this.isLogin" class="caption" flat @click="callLogin">登 录</v-btn>
          <v-menu v-else>
            <template v-slot:activator="{ on }">
              <v-btn class="caption" flat v-on="on">
                {{userName}}
                <v-icon dark>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="logout">
                <v-list-tile-title>退出登录</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-layout>
    </v-toolbar> -->

    <AppNav v-model="drawer"></AppNav>

    <v-content class="content">
      <router-view></router-view>
    </v-content>

    <AppFooter/>
    <CLogin></CLogin>
  </v-app>
</template>

<script>
import AppFooter from "./components/AppFooter";
import AppNav from "./components/AppNav";

export default {
  name: "default",
  components: {
    AppFooter,
    AppNav,
  },
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    transparent() {
      return this.$route.meta.navTransparent || false;
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    userName() {
      if (this.user) {
        return (
          this.user.realName ||
          this.user.userAccount.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
        );
      }
      return "未知";
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.replace({ name: "home" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$toolbar-height: 0px;
$nav-height: 80px;
.app-default {
  .header {
    .v-toolbar__content {
      padding: 0;
    }
  }
  .content {
    margin-top: $toolbar-height + $nav-height;
  }
}
.app-transparent {
  .content {
    margin-top: $toolbar-height;
  }
}
.v-toolbar__title:not(:first-child) {
  margin-left: 12px;
}
</style>